import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import type { CollabEditPlugin } from '@atlaskit/editor-plugin-collab-edit';
import type { ConnectivityPlugin } from '@atlaskit/editor-plugin-connectivity';

import type { AIPlugin } from '@atlassian/editor-plugin-ai';

import type { ConflictResolutionUIPlugin } from '@confluence/editor-presets/entry-points/presets/conflictResolutionUIPlugin.ts';
import { fg } from '@confluence/feature-gating';

export type EditorPresetAPI =
	| PublicPluginAPI<[CollabEditPlugin, ConnectivityPlugin, ConflictResolutionUIPlugin, AIPlugin]>
	| null
	| undefined;

export const useSharedAIState = conditionalHooksFactory(
	() => fg('platform_editor_ai_aifc_streaming'),
	(api: EditorPresetAPI) => {
		const aiIsStreaming =
			useSharedPluginStateSelector(api, 'aiExperience.isStreaming', {
				disabled: !api,
			}) ?? false;
		return { aiIsStreaming };
	},
	(_api: EditorPresetAPI) => {
		return {
			aiIsStreaming: false,
		};
	},
);
